import { Section } from '../../app/aml-score/aml-score-config/aml-score-model';
import { COUNTRIES } from './countries';
import { PROVINCES } from './provinces';

export const getAmlPfScoreConfig = () => {
  const AML_SCORE_PF_CONFIG: Section[] = [
    {
      title: 'CLIENTE',
      questions: [
        {
          id: 1,
          description: 'Persona Politicamente Esposta (PEP) o PIL',
          weight: 1,
          options: [
            { id: 1, view: 'PEP', value: 131 },
            { id: 2, view: 'Legame con PEP', value: 131 },
            { id: 3, view: 'No', value: 0 },
          ],
        },
        {
          id: 2,
          description: "Presente all'interno delle liste antiterrorismo",
          weight: 1,
          options: [
            { id: 4, view: 'Sì', value: 131 },
            { id: 5, view: 'No', value: 0 },
          ],
        },
        {
          id: 3,
          description: 'Indici reputazionali negativi',
          weight: 1,
          options: [
            {
              id: 6,
              view: 'Condanne penali, tributarie o amministrativi rilevanti',
              value: 131,
            },
            {
              id: 7,
              view: 'Procedimenti penali, tributarie o amministrativi rilevanti in corso',
              value: 131,
            },
            { id: 8, view: 'No', value: 0 },
          ],
        },
        {
          id: 4,
          description: 'Paese di residenza',
          weight: 1,
          options: COUNTRIES,
        },
        {
          id: 5,
          description: 'Provincia di residenza',
          weight: 1,
          options: PROVINCES,
          parent: '4',
          parentMatchValue: {
            view: 'Italia',
            value: 0,
            sigla2: 'IT',
            sigla3: 'ITA',
            id: 'ITA',
          },
          disabled: true,
        },
        {
          id: 6,
          description: 'Professione',
          weight: 1,
          options: [
            { id: 11, view: 'Dipendente PA', value: 10 },
            { id: 12, view: 'Imprenditore individuale', value: 20 },
            { id: 13, view: 'Lavoratore subordinato privato', value: 10 },
            { id: 14, view: 'Casalinga', value: 30 },
            { id: 15, view: 'Autonomo/libero professionista', value: 20 },
            { id: 16, view: 'Ministro di culto', value: 10 },
            { id: 17, view: 'Non occupato', value: 30 },
            { id: 18, view: 'Studente', value: 80 },
            { id: 19, view: 'Pensionato', value: 10 },
            { id: 20, view: 'Altro', value: 30 },
          ],
        },
        {
          id: 7,
          description: 'Attività svolta',
          weight: 1,
          options: [
            {
              id: 21,
              view: 'Agricoltura, silvicultura e pesca',
              value: 10,
            },
            { id: 22, view: 'Altre attività di servizi', value: 50 },
            { id: 23, view: 'Altro', value: 131 },
            { id: 24, view: 'Appalti', value: 131 },
            { id: 25, view: 'Assistenza sociale', value: 10 },
            {
              id: 26,
              view: 'Attività artistiche, sportive, di intrattenimento e divertimento',
              value: 10,
            },
            {
              id: 27,
              view: 'Attività dei servizi di alloggio e di ristorazione',
              value: 50,
            },
            {
              id: 28,
              view: 'Attività di famiglie e convivenze come datori di lavoro per personale domestico; produzione di beni e servizi indiferenziati per uso proprio da parte di famiglie e convivenze',
              value: 50,
            },
            {
              id: 29,
              view: 'Attività finanziarie e assicurative',
              value: 10,
            },
            { id: 30, view: 'Attività immobiliari', value: 50 },
            { id: 31, view: 'Attività manifatturiere', value: 50 },
            {
              id: 32,
              view: 'Attività professionali, scientifiche e tecniche',
              value: 10,
            },
            { id: 33, view: 'Cambio valute', value: 131 },
            {
              id: 34,
              view: 'Commercio e/o produzione armi, difesa',
              value: 131,
            },
            {
              id: 35,
              view: 'Commercio, Riparazione di autoveicoli e motocicli',
              value: 50,
            },
            { id: 36, view: 'Compro oro', value: 131 },
            {
              id: 37,
              view: 'Computer/telefonia o beni tecnologici di largo consumo',
              value: 10,
            },
            {
              id: 38,
              view: 'Costruzione e ristrutturazioni edilizie, movimento terra',
              value: 131,
            },
            {
              id: 39,
              view: 'Estrazione di minerali da cave e miniere',
              value: 131,
            },
            {
              id: 40,
              view: 'Fornitura di acqua, reti fognarie, attività di gestione dei rifiuti e risanamento',
              value: 131,
            },
            {
              id: 41,
              view: 'fornitura di energia elettrica, gas, vapore e aria condizionata',
              value: 50,
            },
            {
              id: 42,
              view: 'Fornitura e gestione di energie rinnovabili',
              value: 131,
            },
            { id: 43, view: 'Giochi e scommesse', value: 131 },
            { id: 44, view: 'Istruzione', value: 10 },
            { id: 45, view: 'Metalli preziosi', value: 131 },
            { id: 46, view: 'Money transfer', value: 131 },
            {
              id: 47,
              view: 'Noleggio, agenzie di viaggio, servizi di supporto alle imprese',
              value: 10,
            },
            { id: 48, view: "Opere d'arte", value: 131 },
            {
              id: 49,
              view: 'Organizzazione ed organismi extraterritoriali',
              value: 10,
            },
            {
              id: 50,
              view: 'Pubblica amministrazione e Difesa; Assicurazione sociale obbligatoria',
              value: 10,
            },
            {
              id: 51,
              view: 'Raccolta e smaltimento di rifiuti',
              value: 131,
            },
            { id: 52, view: 'Sanità', value: 131 },
            {
              id: 53,
              view: 'Servizi di informazione e comunicazione',
              value: 10,
            },
            {
              id: 54,
              view: "Settori interessati dall'erogazione di fondi pubblici, anche di fonte comunitaria",
              value: 131,
            },
            { id: 55, view: 'Trasporti e magazzinaggio', value: 50 },
            { id: 56, view: 'Trasporto valori', value: 131 },
          ],
        },
        {
          id: 8,
          description: "Area geografica di svolgimento dell'attività",
          weight: 1,
          options: COUNTRIES,
        },
        {
          id: 9,
          description:
            'Ha ricevuto/è in procinto di ricevere finanziamenti pubblici, anche di origine comunitaria',
          weight: 1,
          options: [
            { id: 58, view: 'Sì', value: 131 },
            { id: 59, view: 'No', value: 0 },
          ],
        },
        {
          id: 10,
          description: 'Patrimonio',
          weight: 1,
          options: [
            { id: 60, view: 'fino a 500.000 euro', value: 5 },
            { id: 61, view: 'da 500.001 a 1.000.000 euro', value: 10 },
            { id: 62, view: 'da 1.000.001 a 2.000.000 euro', value: 15 },
            { id: 63, view: 'da 2.000.001 a 5.000.000 euro', value: 20 },
            { id: 64, view: 'da 5.000.001 a 10.000.000 euro', value: 25 },
            { id: 65, view: 'superiore a 10.000.000 euro', value: 30 },
          ],
        },
        {
          id: 11,
          description: 'Reddito',
          weight: 1,
          options: [
            { id: 66, view: 'fino a 100.000 euro', value: 5 },
            { id: 67, view: 'da 100.001 a 250.000 euro', value: 10 },
            { id: 68, view: 'da 250.001 a 500.000 euro', value: 15 },
            { id: 69, view: 'da 500.001 a 1.000.000 euro', value: 20 },
            { id: 70, view: 'da 1.000.001 a 2.000.000 euro', value: 25 },
            { id: 71, view: 'superiore a 2.000.000 euro', value: 30 },
          ],
        },
      ],
    },

    {
      title: 'ESECUTORE',
      questions: [
        {
          id: 12,
          description: 'Persona Politicamente Esposta (PEP) o PIL',
          weight: 1,
          options: [
            { id: 72, view: 'PEP', value: 131 },
            { id: 73, view: 'Legame con PEP', value: 131 },
            { id: 74, view: 'No', value: 0 },
          ],
        },
        {
          id: 13,
          description: "Presente all'interno delle liste antiterrorismo",
          weight: 1,
          options: [
            {
              id: 75,
              view: 'Inserimento in liste delle persone o enti associati ad attività di finanziamento del terrorismo della Commissione Europea, liste OFAC americane o liste ONU',
              value: 131,
            },
            { id: 76, view: 'Non presente', value: 0 },
            {
              id: 77,
              view: 'Reputazione negativa (Sanzioni penali o amministrative rilevanti, indagini in corso o notizie negative)',
              value: 131,
            },
          ],
        },
        {
          id: 14,
          description: 'Indici reputazionali negativi',
          weight: 1,
          options: [
            {
              id: 78,
              view: 'Con precedenti condanne penali o fiscali, per danni erariali o per responsabilità amministrativa ex D.Lgs. 231/2001',
              value: 131,
            },
            {
              id: 79,
              view: 'Con procedimenti penali o fiscali in corso',
              value: 131,
            },
            { id: 80, view: 'No', value: 0 },
          ],
        },
        {
          id: 15,
          description: "Relazione dell'esecutore con il cliente",
          weight: 1,
          options: [
            { id: 81, view: 'Altro', value: 5 },
            { id: 82, view: 'Amministratore di Sostegno', value: 3 },
            { id: 83, view: 'Curatore', value: 3 },
            { id: 84, view: 'Delegato/procuratore', value: 3 },
            { id: 85, view: 'Tutore', value: 3 },
          ],
        },
      ],
    },
    {
      title: 'TITOLARE EFFETTIVO',
      questions: [
        {
          id: 16,
          description: 'Persona Politicamente Esposta (PEP) o PIL',
          weight: 1,
          options: [
            { id: 86, view: 'PEP', value: 131 },
            { id: 87, view: 'Legame con PEP', value: 131 },
            { id: 88, view: 'No', value: 0 },
          ],
        },
        {
          id: 17,
          description: "Presente all'interno delle liste antiterrorismo",
          weight: 1,
          options: [
            {
              id: 89,
              view: 'Inserimento in liste delle persone o enti associati ad attività di finanziamento del terrorismo della Commissione Europea, liste OFAC americane o liste ONU',
              value: 131,
            },
            { id: 90, view: 'Non presente', value: 0 },
            {
              id: 91,
              view: 'Reputazione negativa (Sanzioni penali o amministrative rilevanti, indagini in corso o notizie negative)',
              value: 131,
            },
          ],
        },
        {
          id: 18,
          description: 'Indici reputazionali negativi',
          weight: 1,
          options: [
            {
              id: 92,
              view: 'Con precedenti condanne penali o fiscali, per danni erariali o per responsabilità amministrativa ex D.Lgs. 231/2001',
              value: 131,
            },
            {
              id: 93,
              view: 'Con procedimenti penali o fiscali in corso',
              value: 131,
            },
            { id: 94, view: 'No', value: 0 },
          ],
        },
        {
          id: 19,
          description: 'Paese di residenza',
          weight: 1,
          options: COUNTRIES,
        },
        {
          id: 20,
          description: 'Professione',
          weight: 1,
          options: [
            { id: 96, view: 'Dipendente PA', value: 10 },
            { id: 97, view: 'Imprenditore individuale', value: 20 },
            { id: 98, view: 'Lavoratore subordinato privato', value: 10 },
            { id: 99, view: 'Casalinga', value: 30 },
            { id: 100, view: 'Autonomo/libero professionista', value: 20 },
            { id: 101, view: 'Ministro di culto', value: 10 },
            { id: 102, view: 'Non occupato', value: 30 },
            { id: 103, view: 'Studente', value: 80 },
            { id: 104, view: 'Pensionato', value: 10 },
            { id: 105, view: 'Altro', value: 30 },
          ],
        },
        {
          id: 21,
          description: "Area geografica di svolgimento dell'attività",
          weight: 1,
          options: COUNTRIES,
        },
        {
          id: 22,
          description: 'Relazione del titolare effettivo con il cliente',
          weight: 1,
          options: [
            { id: 107, view: 'Familiare/personale', value: 3 },
            { id: 108, view: 'Finanziaria', value: 3 },
            { id: 109, view: 'Lavorativa', value: 3 },
          ],
        },
        {
          id: 23,
          description: 'Patrimonio',
          weight: 1,
          options: [
            { id: 110, view: 'fino a 500.000 euro', value: 5 },
            { id: 111, view: 'da 500.001 a 1.000.000 euro', value: 10 },
            { id: 112, view: 'da 1.000.001 a 2.000.000 euro', value: 15 },
            { id: 113, view: 'da 2.000.001 a 5.000.000 euro', value: 20 },
            { id: 114, view: 'da 5.000.001 a 10.000.000 euro', value: 25 },
            { id: 115, view: 'superiore a 10.000.000 euro', value: 30 },
          ],
        },
        {
          id: 24,
          description: 'Reddito',
          weight: 1,
          options: [
            { id: 116, view: 'fino a 100.000 euro', value: 5 },
            { id: 117, view: 'da 100.001 a 250.000 euro', value: 10 },
            { id: 118, view: 'da 250.001 a 500.000 euro', value: 15 },
            { id: 119, view: 'da 500.001 a 1.000.000 euro', value: 20 },
            { id: 120, view: 'da 1.000.001 a 2.000.000 euro', value: 25 },
            { id: 121, view: 'superiore a 2.000.000 euro', value: 30 },
          ],
        },
      ],
    },
    {
      title: 'RAPPORTO',
      questions: [
        {
          id: 25,
          description: "Comportamento tenuto dal cliente o dall'esecutore",
          weight: 1,
          options: [
            { id: 122, view: 'Nella norma', value: 0 },
            {
              id: 123,
              view: 'Si rifiuta o si mostra riluttante a fornire le informazioni richieste, ovvero varia ripetutamente e senza apparente giustificazione le informazioni fornite',
              value: 131,
            },
            {
              id: 124,
              view: 'Senza fornire alcuna plausibile giustificazione, adotta un comportamento del tutto inusuale rispetto a quello comunemente tenuto dalla clientela',
              value: 131,
            },
            {
              id: 125,
              view: 'Dimostra una preparazione e conoscenza della materia antiriciclaggio molto profonda e non coerente con la sua professione, o si dimostra particolarmente interessato ed eccessivamente preoccupato',
              value: 131,
            },
          ],
        },
        {
          id: 26,
          description: 'Natura del rapporto',
          weight: 1,
          options: [
            {
              id: 126,
              view: 'Commercializzazione diretta quote di fondi (se la sottoscrizione avviene presso la SGR)',
              value: 10,
            },
            { id: 127, view: 'Trasferimento quote di fondi', value: 15 },
            { id: 128, view: 'Altro', value: 40 },
          ],
        },
        {
          id: 27,
          description: 'Scopo del rapporto',
          weight: 1,
          options: [
            {
              id: 129,
              view: 'Investimento Familiare/Personale',
              value: 10,
            },
            {
              id: 130,
              view: 'Investimento Professionale/Aziendale/Commerciale',
              value: 10,
            },
            { id: 131, view: 'Investimento conto terzi', value: 131 },
            {
              id: 132,
              view: 'Smobilizzo investimento mobiliare / immobiliare',
              value: 15,
            },
            { id: 133, view: 'Altro', value: 131 },
          ],
        },
        {
          id: 28,
          description: 'Importo del rapporto',
          weight: 1,
          options: [
            { id: 134, view: 'fino a 100.000 euro', value: 5 },
            {
              id: 135,
              view: 'da 100.001 euro fino a 250.000 euro',
              value: 20,
            },
            {
              id: 136,
              view: 'da 250.001 euro fino a 500.000 euro',
              value: 30,
            },
            {
              id: 137,
              view: 'da 500.001 euro fino a 1.000.000 euro',
              value: 50,
            },
            { id: 138, view: 'superiore a 1.000.000 euro', value: 131 },
          ],
        },
        {
          id: 29,
          description:
            "Ragionevolezza - congruità economica con la capacità economica-finanziaria del cliente e dell'origine dei fondi dichiarata",
          weight: 1,
          options: [
            { id: 139, view: 'Sì', value: 0 },
            { id: 140, view: 'No', value: 131 },
          ],
        },
        {
          id: 30,
          description:
            "Ragionevolezza - coerenza dell'attività svolta dal cliente con lo scopo del rapporto",
          weight: 1,
          options: [
            { id: 141, view: 'Sì', value: 0 },
            { id: 142, view: 'No', value: 131 },
          ],
        },
        {
          id: 31,
          description: 'Origine dei fondi impiegati',
          weight: 1,
          options: [
            { id: 143, view: 'Reddito da lavoro autonomo', value: 10 },
            { id: 144, view: 'Reddito da lavoro dipendente', value: 10 },
            { id: 145, view: 'Eredità', value: 25 },
            { id: 146, view: 'Finanziamento bancario', value: 15 },
            { id: 147, view: 'Rendita immobiliare', value: 20 },
            { id: 148, view: 'Vendita di beni mobili', value: 15 },
            { id: 149, view: 'Risparmio/saldo conto corrente', value: 10 },
            {
              id: 150,
              view: 'Disinvestimento/Liquidazione strumenti finanziari e altri investimenti',
              value: 10,
            },
            { id: 151, view: 'Vincite/premi', value: 25 },
            { id: 152, view: 'Pensione', value: 10 },
            { id: 153, view: 'Donazione', value: 25 },
            { id: 154, view: 'Altro', value: 50 },
            { id: 155, view: 'Vendita di beni immobili', value: 20 },
          ],
        },
      ],
    },
  ];

  return AML_SCORE_PF_CONFIG;
};
